import { default as abouthTE1htD5URMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsmy86QsDd90Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_938IW0Hb7uTPMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplez00XVKRNtUMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsh6Qo0jo9fcMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93wSr7tFm07XMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view5xo8BDc3I2Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indextkSkMpCFdOMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93Id9Ogy1OHDMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexZJHgof0nv9Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_931AyvZFEPOkMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexjJRweQnEfNMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsapKvE7rpL2Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingssn3UBr1I6hMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews8teWxF8TwmMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93wsDdBwYBZOMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indextAez4yB4VgMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmhStihJJyOiMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmv5WXL0V7crMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarGV9tCmpgvgMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatZAxk5aubOtMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutN7i9cCgeKYMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedcyHJOKDTLBMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersEfwWZCegBkMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_9377lt6UePAgMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editDAVYRTPAXMMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_9384EIeAZGVLMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityyMKp7qC124Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93nJ3Tv2JdotMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93ci7wC3FhAUMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardi9tXHmSUKHMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexnQAQ7DmfQTMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkouthLbbyI9a5rMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45product1OfWo3CfQ6Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsIXse7sDSpgMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93U01zm53F6zMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexHsU2KcocegMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93bMJw8ygGm6Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93XuIbabNLwiMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexjTiwCZKoqnMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_930pQRLAkP1cMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as join9O5YMDrmzzMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/join.vue?macro=true";
import { default as loginopQEpxWEaaMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/login.vue?macro=true";
import { default as logoutq2i56s1cObMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93LEZRADBoQeMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_932ty67aksTPMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93rR6BX1I9Z7Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favorites0kafWiEuo5Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosdFn7qmCpwsMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinanMKOvxbIhMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93xO0uXAZsINMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexIapqUhnqqdMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index7XW3Bl1GbCMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as abouteQVU2At9mBMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentlsBhv615wiMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsUsvA71DrcXMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_931g4AWscufJMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleXg6DqnjEmIMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsi6zHQZw45AMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93Uzgfie3LzJMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewc3LqmkqRR5Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index79ntqTxjHsMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_937UDxGC5wvfMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexJruIsjgK2aMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93JrlsJu3vwdMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexGEr7YTaXNdMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsEjEoFV0ffjMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsQPqCuvWf69Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews3ccZd4FvivMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93eo5eKSbkGPMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexdU02t3f1pTMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexbNP2bsRu9pMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesHGsG8YIgjrMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptions9ugGfOVeFUMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93SFbi2NbqqtMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93n5U8bwYxniMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetrL7lea0eNwMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/reset.vue?macro=true";
import { default as shopKlPTmD68PTMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/shop.vue?macro=true";
import { default as signupw6T47UYkWiMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/signup.vue?macro=true";
import { default as livelSws5MAF0UMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsduztwWEHNiMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93bsnRGDknKuMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactxspWuIZf1XMeta } from "/tmp/build_0b9e7376/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as full1c58avdc29Meta } from "/tmp/build_0b9e7376/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93wsDdBwYBZOMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93wsDdBwYBZOMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93wsDdBwYBZOMeta || {},
    alias: _91product_id_93wsDdBwYBZOMeta?.alias || [],
    redirect: _91product_id_93wsDdBwYBZOMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouthTE1htD5URMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: abouthTE1htD5URMeta?.path ?? "about",
    meta: abouthTE1htD5URMeta || {},
    alias: abouthTE1htD5URMeta?.alias || [],
    redirect: abouthTE1htD5URMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsmy86QsDd90Meta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsmy86QsDd90Meta?.path ?? "events",
    meta: eventsmy86QsDd90Meta || {},
    alias: eventsmy86QsDd90Meta?.alias || [],
    redirect: eventsmy86QsDd90Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_938IW0Hb7uTPMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_938IW0Hb7uTPMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_938IW0Hb7uTPMeta || {},
    alias: _91media_id_938IW0Hb7uTPMeta?.alias || [],
    redirect: _91media_id_938IW0Hb7uTPMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplez00XVKRNtUMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45samplez00XVKRNtUMeta?.path ?? "free-sample",
    meta: free_45samplez00XVKRNtUMeta || {},
    alias: free_45samplez00XVKRNtUMeta?.alias || [],
    redirect: free_45samplez00XVKRNtUMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsh6Qo0jo9fcMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsh6Qo0jo9fcMeta?.path ?? "included-products",
    meta: included_45productsh6Qo0jo9fcMeta || {},
    alias: included_45productsh6Qo0jo9fcMeta?.alias || [],
    redirect: included_45productsh6Qo0jo9fcMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93wSr7tFm07XMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93wSr7tFm07XMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93wSr7tFm07XMeta || {},
    alias: _91media_id_93wSr7tFm07XMeta?.alias || [],
    redirect: _91media_id_93wSr7tFm07XMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view5xo8BDc3I2Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: view5xo8BDc3I2Meta?.path ?? "lessons/:lesson_id()/view",
    meta: view5xo8BDc3I2Meta || {},
    alias: view5xo8BDc3I2Meta?.alias || [],
    redirect: view5xo8BDc3I2Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indextkSkMpCFdOMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indextkSkMpCFdOMeta?.path ?? "lessons",
    meta: indextkSkMpCFdOMeta || {},
    alias: indextkSkMpCFdOMeta?.alias || [],
    redirect: indextkSkMpCFdOMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Id9Ogy1OHDMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93Id9Ogy1OHDMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93Id9Ogy1OHDMeta || {},
    alias: _91media_id_93Id9Ogy1OHDMeta?.alias || [],
    redirect: _91media_id_93Id9Ogy1OHDMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexZJHgof0nv9Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexZJHgof0nv9Meta?.path ?? "playlists/:playlist_id()",
    meta: indexZJHgof0nv9Meta || {},
    alias: indexZJHgof0nv9Meta?.alias || [],
    redirect: indexZJHgof0nv9Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_931AyvZFEPOkMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_931AyvZFEPOkMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_931AyvZFEPOkMeta || {},
    alias: _91media_id_931AyvZFEPOkMeta?.alias || [],
    redirect: _91media_id_931AyvZFEPOkMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexjJRweQnEfNMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexjJRweQnEfNMeta?.path ?? "playlists",
    meta: indexjJRweQnEfNMeta || {},
    alias: indexjJRweQnEfNMeta?.alias || [],
    redirect: indexjJRweQnEfNMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsapKvE7rpL2Meta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsapKvE7rpL2Meta?.path ?? "private-sessions",
    meta: private_45sessionsapKvE7rpL2Meta || {},
    alias: private_45sessionsapKvE7rpL2Meta?.alias || [],
    redirect: private_45sessionsapKvE7rpL2Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingssn3UBr1I6hMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingssn3UBr1I6hMeta?.path ?? "recordings",
    meta: recordingssn3UBr1I6hMeta || {},
    alias: recordingssn3UBr1I6hMeta?.alias || [],
    redirect: recordingssn3UBr1I6hMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews8teWxF8TwmMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviews8teWxF8TwmMeta?.path ?? "reviews",
    meta: reviews8teWxF8TwmMeta || {},
    alias: reviews8teWxF8TwmMeta?.alias || [],
    redirect: reviews8teWxF8TwmMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indextAez4yB4VgMeta?.name ?? "buy-product-product_id",
    path: indextAez4yB4VgMeta?.path ?? "/buy/product/:product_id()",
    meta: indextAez4yB4VgMeta || {},
    alias: indextAez4yB4VgMeta?.alias || [],
    redirect: indextAez4yB4VgMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmhStihJJyOiMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmhStihJJyOiMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmhStihJJyOiMeta || {},
    alias: confirmhStihJJyOiMeta?.alias || [],
    redirect: confirmhStihJJyOiMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmv5WXL0V7crMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmv5WXL0V7crMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmv5WXL0V7crMeta || {},
    alias: confirmv5WXL0V7crMeta?.alias || [],
    redirect: confirmv5WXL0V7crMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarGV9tCmpgvgMeta?.name ?? "calendar",
    path: calendarGV9tCmpgvgMeta?.path ?? "/calendar",
    meta: calendarGV9tCmpgvgMeta || {},
    alias: calendarGV9tCmpgvgMeta?.alias || [],
    redirect: calendarGV9tCmpgvgMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatZAxk5aubOtMeta?.name ?? "chat",
    path: chatZAxk5aubOtMeta?.path ?? "/chat",
    meta: chatZAxk5aubOtMeta || {},
    alias: chatZAxk5aubOtMeta?.alias || [],
    redirect: chatZAxk5aubOtMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_9377lt6UePAgMeta?.name ?? "community-groups-group_id",
    path: _91group_id_9377lt6UePAgMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_9377lt6UePAgMeta || {},
    alias: _91group_id_9377lt6UePAgMeta?.alias || [],
    redirect: _91group_id_9377lt6UePAgMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutN7i9cCgeKYMeta?.name ?? "community-groups-group_id-about",
    path: aboutN7i9cCgeKYMeta?.path ?? "about",
    meta: aboutN7i9cCgeKYMeta || {},
    alias: aboutN7i9cCgeKYMeta?.alias || [],
    redirect: aboutN7i9cCgeKYMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedcyHJOKDTLBMeta?.name ?? "community-groups-group_id-feed",
    path: feedcyHJOKDTLBMeta?.path ?? "feed",
    meta: feedcyHJOKDTLBMeta || {},
    alias: feedcyHJOKDTLBMeta?.alias || [],
    redirect: feedcyHJOKDTLBMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersEfwWZCegBkMeta?.name ?? "community-groups-group_id-members",
    path: membersEfwWZCegBkMeta?.path ?? "members",
    meta: membersEfwWZCegBkMeta || {},
    alias: membersEfwWZCegBkMeta?.alias || [],
    redirect: membersEfwWZCegBkMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editDAVYRTPAXMMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editDAVYRTPAXMMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editDAVYRTPAXMMeta || {},
    alias: community_45profile_45editDAVYRTPAXMMeta?.alias || [],
    redirect: community_45profile_45editDAVYRTPAXMMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_9384EIeAZGVLMeta?.name ?? "community-profile-id",
    path: _91id_9384EIeAZGVLMeta?.path ?? "/community-profile/:id()",
    meta: _91id_9384EIeAZGVLMeta || {},
    alias: _91id_9384EIeAZGVLMeta?.alias || [],
    redirect: _91id_9384EIeAZGVLMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityyMKp7qC124Meta?.name ?? "community",
    path: communityyMKp7qC124Meta?.path ?? "/community",
    meta: communityyMKp7qC124Meta || {},
    alias: communityyMKp7qC124Meta?.alias || [],
    redirect: communityyMKp7qC124Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93nJ3Tv2JdotMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93nJ3Tv2JdotMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93nJ3Tv2JdotMeta || {},
    alias: _91uuid_93nJ3Tv2JdotMeta?.alias || [],
    redirect: _91uuid_93nJ3Tv2JdotMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93ci7wC3FhAUMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93ci7wC3FhAUMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93ci7wC3FhAUMeta || {},
    alias: _91unique_id_93ci7wC3FhAUMeta?.alias || [],
    redirect: _91unique_id_93ci7wC3FhAUMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardi9tXHmSUKHMeta?.name ?? "dashboard",
    path: dashboardi9tXHmSUKHMeta?.path ?? "/dashboard",
    meta: dashboardi9tXHmSUKHMeta || {},
    alias: dashboardi9tXHmSUKHMeta?.alias || [],
    redirect: dashboardi9tXHmSUKHMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexnQAQ7DmfQTMeta?.name ?? "event-details-event_id",
    path: indexnQAQ7DmfQTMeta?.path ?? "/event/details/:event_id()",
    meta: indexnQAQ7DmfQTMeta || {},
    alias: indexnQAQ7DmfQTMeta?.alias || [],
    redirect: indexnQAQ7DmfQTMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkouthLbbyI9a5rMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkouthLbbyI9a5rMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkouthLbbyI9a5rMeta || {},
    alias: checkouthLbbyI9a5rMeta?.alias || [],
    redirect: checkouthLbbyI9a5rMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45product1OfWo3CfQ6Meta?.name ?? "event-details-event_id-select-product",
    path: select_45product1OfWo3CfQ6Meta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45product1OfWo3CfQ6Meta || {},
    alias: select_45product1OfWo3CfQ6Meta?.alias || [],
    redirect: select_45product1OfWo3CfQ6Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsIXse7sDSpgMeta?.name ?? "events",
    path: eventsIXse7sDSpgMeta?.path ?? "/events",
    meta: eventsIXse7sDSpgMeta || {},
    alias: eventsIXse7sDSpgMeta?.alias || [],
    redirect: eventsIXse7sDSpgMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93U01zm53F6zMeta?.name ?? "gifts-uuid",
    path: _91uuid_93U01zm53F6zMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93U01zm53F6zMeta || {},
    alias: _91uuid_93U01zm53F6zMeta?.alias || [],
    redirect: _91uuid_93U01zm53F6zMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexHsU2KcocegMeta?.name ?? "gifts",
    path: indexHsU2KcocegMeta?.path ?? "/gifts",
    meta: indexHsU2KcocegMeta || {},
    alias: indexHsU2KcocegMeta?.alias || [],
    redirect: indexHsU2KcocegMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93bMJw8ygGm6Meta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93bMJw8ygGm6Meta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93bMJw8ygGm6Meta || {},
    alias: _91invitation_id_93bMJw8ygGm6Meta?.alias || [],
    redirect: _91invitation_id_93bMJw8ygGm6Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93XuIbabNLwiMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93XuIbabNLwiMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93XuIbabNLwiMeta || {},
    alias: _91product_id_93XuIbabNLwiMeta?.alias || [],
    redirect: _91product_id_93XuIbabNLwiMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexjTiwCZKoqnMeta?.name ?? "index",
    path: indexjTiwCZKoqnMeta?.path ?? "/",
    meta: indexjTiwCZKoqnMeta || {},
    alias: indexjTiwCZKoqnMeta?.alias || [],
    redirect: indexjTiwCZKoqnMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_930pQRLAkP1cMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_930pQRLAkP1cMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_930pQRLAkP1cMeta || {},
    alias: _91invitation_unique_id_930pQRLAkP1cMeta?.alias || [],
    redirect: _91invitation_unique_id_930pQRLAkP1cMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: join9O5YMDrmzzMeta?.name ?? "join",
    path: join9O5YMDrmzzMeta?.path ?? "/join",
    meta: join9O5YMDrmzzMeta || {},
    alias: join9O5YMDrmzzMeta?.alias || [],
    redirect: join9O5YMDrmzzMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginopQEpxWEaaMeta?.name ?? "login",
    path: loginopQEpxWEaaMeta?.path ?? "/login",
    meta: loginopQEpxWEaaMeta || {},
    alias: loginopQEpxWEaaMeta?.alias || [],
    redirect: loginopQEpxWEaaMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutq2i56s1cObMeta?.name ?? "logout",
    path: logoutq2i56s1cObMeta?.path ?? "/logout",
    meta: logoutq2i56s1cObMeta || {},
    alias: logoutq2i56s1cObMeta?.alias || [],
    redirect: logoutq2i56s1cObMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93LEZRADBoQeMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93LEZRADBoQeMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93LEZRADBoQeMeta || {},
    alias: _91meeting_type_slug_93LEZRADBoQeMeta?.alias || [],
    redirect: _91meeting_type_slug_93LEZRADBoQeMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_932ty67aksTPMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_932ty67aksTPMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_932ty67aksTPMeta || {},
    alias: _91meeting_unique_id_932ty67aksTPMeta?.alias || [],
    redirect: _91meeting_unique_id_932ty67aksTPMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93rR6BX1I9Z7Meta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93rR6BX1I9Z7Meta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93rR6BX1I9Z7Meta || {},
    alias: _91meeting_unique_id_93rR6BX1I9Z7Meta?.alias || [],
    redirect: _91meeting_unique_id_93rR6BX1I9Z7Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites0kafWiEuo5Meta?.name ?? "my-favorites",
    path: my_45favorites0kafWiEuo5Meta?.path ?? "/my-favorites",
    meta: my_45favorites0kafWiEuo5Meta || {},
    alias: my_45favorites0kafWiEuo5Meta?.alias || [],
    redirect: my_45favorites0kafWiEuo5Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosdFn7qmCpwsMeta?.name ?? "my-studios",
    path: my_45studiosdFn7qmCpwsMeta?.path ?? "/my-studios",
    meta: my_45studiosdFn7qmCpwsMeta || {},
    alias: my_45studiosdFn7qmCpwsMeta?.alias || [],
    redirect: my_45studiosdFn7qmCpwsMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinanMKOvxbIhMeta?.name ?? "optin",
    path: optinanMKOvxbIhMeta?.path ?? "/optin",
    meta: optinanMKOvxbIhMeta || {},
    alias: optinanMKOvxbIhMeta?.alias || [],
    redirect: optinanMKOvxbIhMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93xO0uXAZsINMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93xO0uXAZsINMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93xO0uXAZsINMeta || {},
    alias: _91episode_id_93xO0uXAZsINMeta?.alias || [],
    redirect: _91episode_id_93xO0uXAZsINMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexIapqUhnqqdMeta?.name ?? "podcasts-podcast_id",
    path: indexIapqUhnqqdMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexIapqUhnqqdMeta || {},
    alias: indexIapqUhnqqdMeta?.alias || [],
    redirect: indexIapqUhnqqdMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index7XW3Bl1GbCMeta?.name ?? "podcasts",
    path: index7XW3Bl1GbCMeta?.path ?? "/podcasts",
    meta: index7XW3Bl1GbCMeta || {},
    alias: index7XW3Bl1GbCMeta?.alias || [],
    redirect: index7XW3Bl1GbCMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93eo5eKSbkGPMeta?.name ?? "product-product_id",
    path: _91product_id_93eo5eKSbkGPMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93eo5eKSbkGPMeta || {},
    alias: _91product_id_93eo5eKSbkGPMeta?.alias || [],
    redirect: _91product_id_93eo5eKSbkGPMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouteQVU2At9mBMeta?.name ?? "product-product_id-about",
    path: abouteQVU2At9mBMeta?.path ?? "about",
    meta: abouteQVU2At9mBMeta || {},
    alias: abouteQVU2At9mBMeta?.alias || [],
    redirect: abouteQVU2At9mBMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentlsBhv615wiMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentlsBhv615wiMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentlsBhv615wiMeta || {},
    alias: digital_45download_45contentlsBhv615wiMeta?.alias || [],
    redirect: digital_45download_45contentlsBhv615wiMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsUsvA71DrcXMeta?.name ?? "product-product_id-events",
    path: eventsUsvA71DrcXMeta?.path ?? "events",
    meta: eventsUsvA71DrcXMeta || {},
    alias: eventsUsvA71DrcXMeta?.alias || [],
    redirect: eventsUsvA71DrcXMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_931g4AWscufJMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_931g4AWscufJMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_931g4AWscufJMeta || {},
    alias: _91media_id_931g4AWscufJMeta?.alias || [],
    redirect: _91media_id_931g4AWscufJMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleXg6DqnjEmIMeta?.name ?? "product-product_id-free-sample",
    path: free_45sampleXg6DqnjEmIMeta?.path ?? "free-sample",
    meta: free_45sampleXg6DqnjEmIMeta || {},
    alias: free_45sampleXg6DqnjEmIMeta?.alias || [],
    redirect: free_45sampleXg6DqnjEmIMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsi6zHQZw45AMeta?.name ?? "product-product_id-included-products",
    path: included_45productsi6zHQZw45AMeta?.path ?? "included-products",
    meta: included_45productsi6zHQZw45AMeta || {},
    alias: included_45productsi6zHQZw45AMeta?.alias || [],
    redirect: included_45productsi6zHQZw45AMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Uzgfie3LzJMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93Uzgfie3LzJMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93Uzgfie3LzJMeta || {},
    alias: _91media_id_93Uzgfie3LzJMeta?.alias || [],
    redirect: _91media_id_93Uzgfie3LzJMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewc3LqmkqRR5Meta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewc3LqmkqRR5Meta?.path ?? "lessons/:lesson_id()/view",
    meta: viewc3LqmkqRR5Meta || {},
    alias: viewc3LqmkqRR5Meta?.alias || [],
    redirect: viewc3LqmkqRR5Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index79ntqTxjHsMeta?.name ?? "product-product_id-lessons",
    path: index79ntqTxjHsMeta?.path ?? "lessons",
    meta: index79ntqTxjHsMeta || {},
    alias: index79ntqTxjHsMeta?.alias || [],
    redirect: index79ntqTxjHsMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_937UDxGC5wvfMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_937UDxGC5wvfMeta?.path ?? "media/:media_id()",
    meta: _91media_id_937UDxGC5wvfMeta || {},
    alias: _91media_id_937UDxGC5wvfMeta?.alias || [],
    redirect: _91media_id_937UDxGC5wvfMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexJruIsjgK2aMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexJruIsjgK2aMeta?.path ?? "playlists/:playlist_id()",
    meta: indexJruIsjgK2aMeta || {},
    alias: indexJruIsjgK2aMeta?.alias || [],
    redirect: indexJruIsjgK2aMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93JrlsJu3vwdMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93JrlsJu3vwdMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93JrlsJu3vwdMeta || {},
    alias: _91media_id_93JrlsJu3vwdMeta?.alias || [],
    redirect: _91media_id_93JrlsJu3vwdMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexGEr7YTaXNdMeta?.name ?? "product-product_id-playlists",
    path: indexGEr7YTaXNdMeta?.path ?? "playlists",
    meta: indexGEr7YTaXNdMeta || {},
    alias: indexGEr7YTaXNdMeta?.alias || [],
    redirect: indexGEr7YTaXNdMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsEjEoFV0ffjMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsEjEoFV0ffjMeta?.path ?? "private-sessions",
    meta: private_45sessionsEjEoFV0ffjMeta || {},
    alias: private_45sessionsEjEoFV0ffjMeta?.alias || [],
    redirect: private_45sessionsEjEoFV0ffjMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsQPqCuvWf69Meta?.name ?? "product-product_id-recordings",
    path: recordingsQPqCuvWf69Meta?.path ?? "recordings",
    meta: recordingsQPqCuvWf69Meta || {},
    alias: recordingsQPqCuvWf69Meta?.alias || [],
    redirect: recordingsQPqCuvWf69Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews3ccZd4FvivMeta?.name ?? "product-product_id-reviews",
    path: reviews3ccZd4FvivMeta?.path ?? "reviews",
    meta: reviews3ccZd4FvivMeta || {},
    alias: reviews3ccZd4FvivMeta?.alias || [],
    redirect: reviews3ccZd4FvivMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexdU02t3f1pTMeta?.name ?? "product",
    path: indexdU02t3f1pTMeta?.path ?? "/product",
    meta: indexdU02t3f1pTMeta || {},
    alias: indexdU02t3f1pTMeta?.alias || [],
    redirect: indexdU02t3f1pTMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexbNP2bsRu9pMeta?.name ?? "profile",
    path: indexbNP2bsRu9pMeta?.path ?? "/profile",
    meta: indexbNP2bsRu9pMeta || {},
    alias: indexbNP2bsRu9pMeta?.alias || [],
    redirect: indexbNP2bsRu9pMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesHGsG8YIgjrMeta?.name ?? "profile-purchases",
    path: purchasesHGsG8YIgjrMeta?.path ?? "/profile/purchases",
    meta: purchasesHGsG8YIgjrMeta || {},
    alias: purchasesHGsG8YIgjrMeta?.alias || [],
    redirect: purchasesHGsG8YIgjrMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptions9ugGfOVeFUMeta?.name ?? "profile-redemptions",
    path: redemptions9ugGfOVeFUMeta?.path ?? "/profile/redemptions",
    meta: redemptions9ugGfOVeFUMeta || {},
    alias: redemptions9ugGfOVeFUMeta?.alias || [],
    redirect: redemptions9ugGfOVeFUMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93SFbi2NbqqtMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93SFbi2NbqqtMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93SFbi2NbqqtMeta || {},
    alias: _91quiz_id_93SFbi2NbqqtMeta?.alias || [],
    redirect: _91quiz_id_93SFbi2NbqqtMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93n5U8bwYxniMeta?.name ?? "reset-password-uid-token",
    path: _91token_93n5U8bwYxniMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93n5U8bwYxniMeta || {},
    alias: _91token_93n5U8bwYxniMeta?.alias || [],
    redirect: _91token_93n5U8bwYxniMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetrL7lea0eNwMeta?.name ?? "reset",
    path: resetrL7lea0eNwMeta?.path ?? "/reset",
    meta: resetrL7lea0eNwMeta || {},
    alias: resetrL7lea0eNwMeta?.alias || [],
    redirect: resetrL7lea0eNwMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopKlPTmD68PTMeta?.name ?? "shop",
    path: shopKlPTmD68PTMeta?.path ?? "/shop",
    meta: shopKlPTmD68PTMeta || {},
    alias: shopKlPTmD68PTMeta?.alias || [],
    redirect: shopKlPTmD68PTMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupw6T47UYkWiMeta?.name ?? "signup",
    path: signupw6T47UYkWiMeta?.path ?? "/signup",
    meta: signupw6T47UYkWiMeta || {},
    alias: signupw6T47UYkWiMeta?.alias || [],
    redirect: signupw6T47UYkWiMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: livelSws5MAF0UMeta?.name ?? "streaming-event_id-live",
    path: livelSws5MAF0UMeta?.path ?? "/streaming/:event_id()/live",
    meta: livelSws5MAF0UMeta || {},
    alias: livelSws5MAF0UMeta?.alias || [],
    redirect: livelSws5MAF0UMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsduztwWEHNiMeta?.name ?? "tips",
    path: tipsduztwWEHNiMeta?.path ?? "/tips",
    meta: tipsduztwWEHNiMeta || {},
    alias: tipsduztwWEHNiMeta?.alias || [],
    redirect: tipsduztwWEHNiMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93bsnRGDknKuMeta?.name ?? "waiver-uuid",
    path: _91uuid_93bsnRGDknKuMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93bsnRGDknKuMeta || {},
    alias: _91uuid_93bsnRGDknKuMeta?.alias || [],
    redirect: _91uuid_93bsnRGDknKuMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactxspWuIZf1XMeta?.name ?? "widgets-calendars-compact",
    path: compactxspWuIZf1XMeta?.path ?? "/widgets/calendars/compact",
    meta: compactxspWuIZf1XMeta || {},
    alias: compactxspWuIZf1XMeta?.alias || [],
    redirect: compactxspWuIZf1XMeta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: full1c58avdc29Meta?.name ?? "widgets-calendars-full",
    path: full1c58avdc29Meta?.path ?? "/widgets/calendars/full",
    meta: full1c58avdc29Meta || {},
    alias: full1c58avdc29Meta?.alias || [],
    redirect: full1c58avdc29Meta?.redirect,
    component: () => import("/tmp/build_0b9e7376/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]